import script from "./FaqCategory.vue?vue&type=script&setup=true&lang=js"
export * from "./FaqCategory.vue?vue&type=script&setup=true&lang=js"

import "./FaqCategory.vue?vue&type=style&index=0&id=6a50dcf0&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a50dcf0"]])

export default __exports__